import { useMemo } from 'react';

import MailerSettingsService from '../api/MailerSettingsService';
import useMailerDriver from './useMailerDriver';

const useMailerSettingsService = () => {
    const { apiRoutes } = useMailerDriver();

    return useMemo(
        () => MailerSettingsService.getInstance(apiRoutes.API_BASE_URL),
        [apiRoutes.API_BASE_URL]
    );
};

export default useMailerSettingsService;
